/**
 * Cross-Sell Products - Quick Add to Cart
 * Handles variant selection and add to cart for related products
 */

(function() {
  'use strict';

  class CrossSell {
    constructor() {
      this.container = document.querySelector('[data-cross-sell-container]');
      if (!this.container) return;

      this.init();
    }

    init() {
      // Handle color/variant selection via radio input
      this.container.addEventListener('change', (e) => {
        if (e.target.type === 'radio' && e.target.closest('[data-cross-sell-option]')) {
          this.handleVariantChange(e.target);
        }
      });

      // Handle add to cart
      this.container.addEventListener('click', (e) => {
        const addBtn = e.target.closest('[data-add-to-cart]');
        if (addBtn && !addBtn.disabled) {
          this.handleAddToCart(addBtn);
        }
      });
    }

    handleVariantChange(radioInput) {
      const item = radioInput.closest('.m-cross-sell-item');
      const variantId = radioInput.dataset.variantId;
      const productId = radioInput.dataset.productId;
      const imageUrl = radioInput.dataset.image;
      const price = radioInput.dataset.price;

      // Update image if available
      if (imageUrl) {
        const imgElement = item.querySelector('[data-cross-sell-image]');
        if (imgElement) {
          imgElement.src = imageUrl;
        }
      }

      // Update add to cart button
      const addBtn = item.querySelector('[data-add-to-cart]');
      addBtn.dataset.variantId = variantId;
      addBtn.dataset.productId = productId;

      // Update price directly
      if (price) {
        const priceElement = item.querySelector('.m-cross-sell-price');
        if (priceElement) {
          priceElement.textContent = this.formatMoney(parseInt(price));
        }
      }
    }

    async updatePrice(item, variantId) {
      const productId = item.dataset.productId;
      const priceElement = item.querySelector('.m-cross-sell-price');

      try {
        const response = await fetch(`/products/${productId}.js`);
        const product = await response.json();
        const variant = product.variants.find(v => v.id == variantId);

        if (variant && priceElement) {
          priceElement.textContent = this.formatMoney(variant.price);
        }
      } catch (error) {
        console.error('Error fetching product data:', error);
      }
    }

    async handleAddToCart(btn) {
      const variantId = btn.dataset.variantId;
      const item = btn.closest('.m-cross-sell-item');

      // Disable button temporarily
      btn.disabled = true;

      try {
        // Add to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (response.ok) {
          // Check if SlideCart is being used (third-party app)
          if (typeof SLIDECART_UPDATE === 'function') {
            // Update cart content
            SLIDECART_UPDATE();

            // Open SlideCart
            setTimeout(() => {
              if (typeof SLIDECART_OPEN === 'function') {
                SLIDECART_OPEN();
              } else if (typeof SLIDECART_SHOW === 'function') {
                SLIDECART_SHOW();
              } else {
                // Fallback: simulate click on cart icon
                const cartIcon = document.querySelector('.m-cart-icon-bubble') ||
                                 document.querySelector('[data-cart-icon]') ||
                                 document.querySelector('.cart-icon');
                if (cartIcon) {
                  cartIcon.click();
                }
              }
            }, 300);
          } else {
            // Fallback to native Minimog cart drawer
            const cartDrawer = document.querySelector('m-cart-drawer') || document.getElementById('MinimogCartDrawer');

            if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
              cartDrawer.onCartDrawerUpdate();
              setTimeout(() => {
                cartDrawer.open();
              }, 200);
            }
          }

          // Re-enable button
          btn.disabled = false;
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        btn.disabled = false;
        alert('Unable to add product to cart. Please try again.');
      }
    }

    formatMoney(cents) {
      const amount = cents / 100;
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount).replace(',00', '');
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CrossSell());
  } else {
    new CrossSell();
  }
})();
